import { FC } from "react"

export const MeetTheSpecialistsApp: FC = ({ children }) => {
  return <>{children}</>
}
